<template>
  <div class="mobile-repair-form">
    <a-form ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="年度" name="year">
        <a-input-number
          v-model:value="formState.year"
          :disabled="!isEditable"
          style="width: 100%"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="设备类型" name="serialType">
        <serial-cascader-vue
          @handleSerialChange="handleSerialChange"
          :disabled="!isEditable"
          :echoData="selectSerial"
        >
        </serial-cascader-vue>
      </a-form-item>

      <a-form-item label="机身号" name="serial">
        <a-input
          v-model:value="formState.serial"
          :disabled="!isEditable"
        ></a-input>
      </a-form-item>

      <a-form-item label="对接人" name="contactPerson">
        <a-input
          v-model:value="formState.contactPerson"
          :disabled="!isEditable"
        />
      </a-form-item>

      <a-form-item label="返修地址" name="returnAddress">
        <a-select
          v-model:value="formState.returnAddress"
          placeholder="请选择返修地址"
          allowClear
        >
          <a-select-option value="广州">广州</a-select-option>
          <a-select-option value="长沙">长沙</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="客户信息"
        name="repairCustomerInfo"
        v-if="customInfoview"
      >
        <a-textarea
          v-model:value="formState.repairCustomerInfo"
          :disabled="!isEditable"
        />
      </a-form-item>

      <a-form-item label="备注" name="notes">
        <a-textarea v-model:value="formState.notes" :disabled="!isEditable" />
      </a-form-item>

      <a-form-item label="售后问题" name="afterSaleProblemDescription">
        <after-sale-qeustion-vue
          :questionLists="formState.afterSaleProblemDescription"
          ref="questionRef"
        ></after-sale-qeustion-vue>
      </a-form-item>

      <accessory-vue
        v-if="formState.serialType"
        :machine="formState.serialType"
        :accessoryList="accessoryList"
        ref="accessoryRef"
        :disabled="!isEditable"
        :ismobile="true"
      >
      </accessory-vue>

      <a-form-item label="售后问题图片">
        <upload-img-vue
          :attachment="formState.picture"
          :disabled="!isEditable"
          ref="uploadImg"
        ></upload-img-vue>
      </a-form-item>
      <a-form-item label="售后问题视频">
        <upload-video-vue
          :attachment="formState.video"
          :disabled="!isEditable"
          ref="uploadVideo"
        ></upload-video-vue>
      </a-form-item>
    </a-form>

    <a-space>
      <a-button @click="backPre">返回</a-button>
      <a-button @click="handleOk" type="primary">提交表单</a-button>
    </a-space>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  computed,
  onMounted,
  nextTick,
  watch,
} from "vue";
import { useStore } from "vuex";
import { Toast, uploadMedia } from "@/utils/index";
import {
  saveOrUpdateRepairEquipment,
  updateSwanAccessory,
  updateColumbaAccessory,
} from "@/request/view/repair";
import { handleUpdatePage, getRepairListData } from "./serve/search";
import { getshowAccessoryByReq } from "./serve/getReqAccessory";
import uploadImgVue from "../repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "../repairprogress/compoments/uploadVideo.vue";
import accessoryVue from "./components/accessory.vue";
import afterSaleQeustionVue from "./components/afterSaleQeustion.vue";
import serialCascaderVue from "./components/serialCascader.vue";
import { useRoute } from "vue-router";
import router from "@/router";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    accessoryVue,
    serialCascaderVue,
    afterSaleQeustionVue,
  },
  setup() {
    const store = useStore();

    const selectSerial = ref([]);
    // 返修表单
    const formState = reactive({
      id: null,
      year: null,
      serial: null,
      serialType: null,
      afterSaleProblemDescription: null,
      contactPerson: null,
      repairCustomerInfo: null,
      createUserId: store.getters.user.id,
      picture: null,
      video: null,
      notes: null,
      isEditable: null,
      repairProcess: null,
      returnAddress: null,
    });

    const isEditable = computed(() => {
      return formState.repairProcess === null || formState.repairProcess === 0;
    });

    const formRef = ref();

    const accessoryRef = ref();
    const accessoryList = reactive([]);
    const uploadImg = ref();

    const uploadVideo = ref();

    const questionRef = ref();
    const setAccessoryList = (list) => {
      list.forEach((item) => {
        if (item.val) {
          accessoryList.push(item);
        }
      });
    };
    // 标配确认方法
    const handleAccessoryOk = () => {
      if (!accessoryRef.value) {
        return Toast("warning", "请选择配件", 3);
      }
      accessoryRef.value
        .validateAccessory()
        .then((res) => {
          accessoryList.length = 0;
          const [standardList, optionalList] = res;
          setAccessoryList(standardList);
          if (optionalList) setAccessoryList(optionalList);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // 校验配件
    const checkAccessory = async () => {
      console.log(accessoryList.length);
      if (accessoryList.length === 0) {
        return Promise.reject("请选择配件");
      }
      return Promise.resolve();
    };
    const customInfoview = ref(true);
    const rules = reactive({
      year: [
        {
          required: true,
          message: "请输入年度",
          trigger: "blur",
          type: "number",
        },
      ],
      serial: [
        {
          required: true,
          message: "请输入设备号",
          trigger: "blur",
          type: "string",
        },
      ],
      serialType: [
        {
          required: true,
          message: "请选择设备类型",
          trigger: "blur",
          type: "string",
        },
      ],
      afterSaleProblemDescription: [
        {
          required: true,
          message: "请输入售后问题描述",
          trigger: "blur",
        },
      ],
      contactPerson: [
        {
          required: true,
          message: "请输入对接人",
          trigger: "blur",
          type: "string",
        },
      ],
      repairCustomerInfo: [
        {
          required: true,
          message: "请输入返修客户信息",
          trigger: "blur",
          type: "string",
        },
      ],
      returnAddress: [
        {
          required: true,
          message: "请选择返修地址",
          trigger: "blur",
          type: "string",
        },
      ],
      accessory: [
        {
          required: true,
          validator: checkAccessory,
          trigger: "blur",
        },
      ],
    });

    const handleSerialChange = (e) => {
      formState.serialType = e;
    };

    // 设置请求列表
    const setRequestAccessory = () => {
      let accessoryObj = {};
      accessoryList.forEach((item) => {
        accessoryObj[item.searchVal] = item.val;
      });
      return accessoryObj;
    };

    // 获取问题列表的数据
    const getAfterSaleProblemDescription = () => {
      const list = [];
      questionRef.value.questionList.forEach((item) => {
        list.push({
          value: item.value,
          disabled: true,
        });
      });
      return JSON.stringify(list);
    };

    const accessoryId = ref(null);

    let isEcho = false;

    const resetForm = () => {
      selectSerial.value.length = 0;
      accessoryList.length = 0;
      formState.id = null;
      formState.year = null;
      formState.serial = null;
      formState.afterSaleProblemDescription = null;
      formState.contactPerson = null;
      formState.repairCustomerInfo = null;
      formState.serialType = null;
      formState.picture = null;
      formState.video = null;
      formState.notes = null;
      formState.isEditable = null;
      formState.repairProcess = null;
      formState.returnAddress = null;
      formState.createUserId = store.getters.user.id;
      customInfoview.value = true;
      formState.year = new Date().getFullYear();
      accessoryId.value = null;
      formRef.value.clearValidate();
      questionRef.value.resetList();

      if (!isEcho) {
        handleUpdatePage(1);
      }

      getRepairListData();

      isEcho = false;
    };

    const handleOk = () => {
      handleAccessoryOk();
      setTimeout(() => {
        formRef.value
          .validate()
          .then(async () => {
            let imgFileUrl = null;
            let videoFileUrl = null;
            // 配件信息
            const accessory = setRequestAccessory();
            if (accessoryId.value === null) {
              formState.columbaAccessory =
                formState.serialType.indexOf("天鸽") !== -1 ? accessory : null;
              formState.swanAccessory =
                formState.serialType.indexOf("天鹅") !== -1 ? accessory : null;
            } else {
              const accessoryFn =
                formState.serialType.indexOf("天鸽") !== -1
                  ? updateColumbaAccessory
                  : updateSwanAccessory;
              const params = Object.assign(accessory, {
                id: accessoryId.value,
              });
              await accessoryFn(params)
                .then((res) => {
                  console.log(res);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            // 售后问题
            const afterSaleProblemDescription =
              getAfterSaleProblemDescription();
            formState.afterSaleProblemDescription = afterSaleProblemDescription;
            // 上传文件
            await uploadMedia(uploadImg, uploadVideo).then((res) => {
              imgFileUrl = JSON.stringify(res[0]);
              videoFileUrl = JSON.stringify(res[1]);
            });

            formState.picture = imgFileUrl;
            formState.video = videoFileUrl;
            saveOrUpdateRepairEquipment(formState).then((res) => {
              resetForm();
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              nextTick(() => {
                router.back();
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }, 0);
    };

    const echoMobileForm = (data, type) => {
      if (type === "echoRepairForm" && data) {
        isEcho = true;
        selectSerial.value.length = 0;
        const record = JSON.parse(data);
        getshowAccessoryByReq(record.serialType, record.id)
          .then((res) => {
            accessoryList.length = 0;
            setAccessoryList(res.findList);
            accessoryId.value = res.id;
          })
          .catch((err) => {
            console.log(err);
          });
        const machine = record.serialType.replace(/[^\u4E00-\u9FA5]/g, "");
        const machineType = record.serialType.replace(/[^a-za-z0-9]/g, "");
        selectSerial.value.push(machine, machineType);
        formState.id = record.id;
        formState.year = Number(record.year);
        formState.serial = record.serial;
        formState.afterSaleProblemDescription =
          record.afterSaleProblemDescription;
        formState.contactPerson = record.contactPerson;
        formState.repairCustomerInfo = record.repairCustomerInfo;
        formState.serialType = record.serialType;
        formState.video = record.video;
        formState.picture = record.picture;
        formState.notes = record.notes;
        formState.isEditable = record.isEditable;
        formState.returnAddress = record.returnAddress;
        formState.repairProcess = record.repairProcess;
        formState.createUserId = record.createUserId;
      } else {
        nextTick(() => {
          resetForm();
        });
      }
    };

    const backPre = () => {
      resetForm();

      nextTick(() => {
        router.back();
      });
    };

    onMounted(() => {
      nextTick(() => {
        rules.afterSaleProblemDescription[0].validator =
          questionRef.value.checkQuestionList;
      });
    });

    const route = useRoute();
    watch(
      () => route,
      (val) => {
        echoMobileForm(val.query.data, val.query.type);

        if (val.query.type === "echoRepairForm") {
          customInfoview.value = val.query.authority === "true" ? true : false;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      formState,
      accessoryRef,
      uploadImg,
      uploadVideo,
      questionRef,
      isEditable,
      handleSerialChange,
      rules,
      accessoryList,
      handleOk,
      formRef,
      selectSerial,
      backPre,
      customInfoview,
    };
  },
});
</script>

<style lang="less" scoped>
.mobile-repair-form {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  padding: 20px 20px;
}
</style>
